<template>
  <div class="touch-for-fabricators-page">
    <div class="loading-spinner-outer" v-if="sending">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="box _gradient-bar">
      <div class="powered-by-title-bar">
        <div class="title">
          <h1>
            TOUCH
          </h1>
        </div>
        <div class="logo">
          <img src="/images/powered-by-logo-touch.png">
        </div>
      </div>
      <div class="box-1">
        <h1>
          One System ... for every link in your supply chain
        </h1>
        <p>
          TOUCH manages everything from the consumer enquiry and quoting to production and supply
          with everything else in between...and afterwards!
        </p>
        <a class="btn-primary" @click="enquiry_box_open = true">
          Make Enquiry
        </a>
        <div class="image">
          <img src="/images/touch-for-fabricators-page-1.png">
        </div>
      </div>
      <div class="box-2">
        <div class="content">
          <h1 class="align-center">
            What is TOUCH?
          </h1>
          <p class="align-center">
            TOUCH was created as an end to end system with 3 main areas.
          </p>
          <div class="cols">
            <div class="col-1">
              <div class="box">
                <div class="image">
                  <img src="/images/touch-for-fabricators-page-2.png">
                </div>
                <div class="content">
                  <div class="subtitle">
                    TOUCH Business
                  </div>
                  <p>
                    Welcome to the business-end of the process. TOUCH Business is the premium business management system
                    for fabricators.
                  </p>
                  <p class="mb-0">
                    With business you can manage:
                  </p>
                  <ul>
                    <li>
                      Customers
                    </li>
                    <li>
                      Products
                    </li>
                    <li>
                      Pricing & Discounts
                    </li>
                    <li>
                      Quotes & Orders
                    </li>
                    <li>
                      KPI’s
                    </li>
                    <li>
                      Processing Orders
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="box">
                <div class="image">
                  <img src="/images/touch-for-fabricators-page-3.png">
                </div>
                <div class="content">
                  <div class="subtitle">
                    TOUCH Portal
                  </div>
                  <div>
                    <p>
                      Portal allows your installers and trade customers to access design, quote and order your products.
                    </p>
                    <p class="mb-0">
                      With portal your customers can:
                    </p>
                    <ul>
                      <li>
                        Create, edit and uplift quotes
                      </li>
                      <li>
                        Place orders
                      </li>
                      <li>
                        Manage staff
                      </li>
                      <li>
                        View fabricator marketing
                      </li>
                      <li>
                        Read fabricator news
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="box">
                <div class="image">
                  <img src="/images/touch-for-fabricators-page-4.png">
                </div>
                <div class="content">
                  <div class="subtitle">
                    TOUCH Data
                  </div>
                  <div>
                    <p>
                      TOUCH will come populated with your specific product range, data and product specifications.
                      The images used will mimic your true products allowing your customers to create accurate quotes
                      and orders and push them to be processed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-3">
        <div class="title-bar">
          <div class="icon">
            <img src="/images/touch-icon-portal.png">
          </div>
          <div class="title">
            <h1>
              Portal benefits to installers
            </h1>
          </div>
        </div>
        <div class="bullet-tabs-container _nav-top">
          <div class="nav-tabs">
            <div class="nav-tab" @click="box_3_tab_open = 1" :class="{ 'active' : box_3_tab_open === 1 }">
              <div class="inner-tab">
                Quote Creation
              </div>
            </div>
            <div class="nav-tab" @click="box_3_tab_open = 2" :class="{ 'active' : box_3_tab_open === 2 }">
              <div class="inner-tab">
                Keep Track of Quotes
              </div>
            </div>
            <div class="nav-tab" @click="box_3_tab_open = 3" :class="{ 'active' : box_3_tab_open === 3 }">
              <div class="inner-tab">
                Uplift Prices
              </div>
            </div>
            <div class="nav-tab" @click="box_3_tab_open = 4" :class="{ 'active' : box_3_tab_open === 4 }">
              <div class="inner-tab">
                Process Orders
              </div>
            </div>
          </div>
          <div class="tab-content active _quote-creation" v-show="box_3_tab_open === 1">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Quick and Easy
                      Quote Creation
                    </h1>
                    <p>
                      TOUCH Portal allows you to create quick and easy bespoke quotes. Once the quote is complete you
                      can download a detailed summary along with a price and then email
                      this to your customer. This is perfectfor customers who may have called to request a quote or
                      visited your showroom.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-5.png">
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _keep-track-of-quotes" v-show="box_3_tab_open === 2">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Keep Track of Quotes
                    </h1>
                    <p>
                      TOUCH is not just another designer but a full features CRM system. A
                      ny quotes your customers process on your portal system are permanently stored and they can
                      retrieve and edit them at any point 24/7. The quoting system provides for different quote
                      versions.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <!--<img src="/images/touch-for-fabricators-page-6.png">-->
                  <img src="/images/touch-for-fabricators-page-5.png">
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _uplift-prices" v-show="box_3_tab_open === 3">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Uplift Prices
                    </h1>
                    <p>
                      Portal gives your customers benefits in the quoting process.
                      Your price to them is calculated in real-time and can either be uplifted automatically or they can
                      manually set the sales price
                      either by item or total quote to produce a quote to the consumer with your customer's own logo and
                      colour scheme.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-5.png">
                  <!--<img src="/images/touch-for-fabricators-page-7.png">-->
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _process-orders" v-show="box_3_tab_open === 4">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Process Orders
                    </h1>
                    <p>
                      Once the quote is accepted by the consumer, your customer can instantly convert the quote to an
                      order and overlay with final survey details prior to submitting the order with you.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-5.png">
                  <!--<img src="/images/touch-for-fabricators-page-8.png">-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-4">
        <div class="content">
          <div class="cols">
            <div class="col">
                <div class="col-inner">
                    <div class="image">
                        <img src="/images/touch-for-fabricators-page-9.png">
                    </div>
                    <div class="title">
                        Prices and Discounts
                    </div>
                    <div class="description">
                        TOUCH features the most advanced, flexible pricing engine of any system available today. It comes
                        bespoke with your list prices, including customer-specific discounts across our entire range.
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="col-inner">
                    <div class="image">
                        <img src="/images/touch-for-fabricators-page-10.png">
                    </div>
                    <div class="title">
                        Delivery & Depots
                    </div>
                    <div class="description">
                        TOUCH lets you enter details of your delivery depots, complete with opening and closing times, so that
                        we can make sure we deliver at the time that’s right for you.
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="col-inner">
                    <div class="image">
                        <img src="/images/touch-for-fabricators-page-11.png">
                    </div>
                    <div class="title">
                        Staff and licenses
                    </div>
                    <div class="description">
                        Once you’re set up on our system, you’re in control and can configure your TOUCH Portal account for your
                        own staff so that they can get to work generating quotes and placing orders.
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="col-inner">
                    <div class="image">
                        <img src="/images/touch-for-fabricators-page-12.png">
                    </div>
                    <div class="title">
                        News and Marketing
                    </div>
                    <div class="description">
                        Stay up to date with your fabricators latest news and marketing materials with all the downloads you
                        need to help you sell and market your products.
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-5">
        <div class="cols">
          <div class="col-info">
            <div>
              <div class="title-bar">
                <div class="icon">
                  <img src="/images/touch-icon-branded-mode.png">
                </div>
                <div class="title">
                  <h1>
                    Branded Mode Upgrade
                  </h1>
                </div>
              </div>
              <p class="txt-lg">
                Allows installers to generate homeowner
                enquiries via their own website.
              </p>
              <p>
                This slimmed down version of the standard TOUCH Portal ordering tool lets homeowners design their own
                windows and doors online and submit an enquiry direct.
                The product data is automatically synced with your TOUCH Portal system so it’s always up to date.
              </p>
              <p>
                <strong>
                  Upgrade price for installers £45.00
                </strong>
              </p>
            </div>
          </div>
          <div class="col-image">
            <img src="/images/touch-for-fabricators-page-13.png">
          </div>
        </div>
      </div>

      <div class="box-6">
        <div class="title-bar">
          <div class="icon">
            <img src="/images/touch-icon-business.png">
          </div>
          <div class="title">
            <h1>
              Business benefits for Fabricators
            </h1>
          </div>
        </div>
        <div class="cols">
          <div class="col-image">
            <img src="/images/touch-for-fabricators-page-14.png">
          </div>
          <div class="col-info">
            <div>
              <h1>
                Manage your
                product offering
              </h1>
              <p>
                The processing environment within TOUCH strikes the perfect balance of form and function; striving to
                make the process straightforward to users at all levels yet losing none of the capabilities
                required in a system which has to handle such a wide a varied range of products.
              </p>
              <p>
                The ultra high quality product graphics render the actual product in real-time with every visible
                element painstakingly added to the visible image.
              </p>
              <p>
                All warnings and limitations are built in to processing as standard unlike other lightweight designers
                and the user is not only warned that there are issues but is provided with full details of what the
                issues are.
                When processing, all prices are calculated in real-time from the most flexible and advanced pricing
                engine available.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="box-7">
        <div class="title-bar">
          <div class="title">
            <h1>
              Business streamlines management of
              your customers, quotes and orders.
            </h1>
          </div>
        </div>
        <div class="bullet-tabs-container">
          <div class="nav-tabs">
            <div class="nav-tab" @click="box_6_tab_open = 1" :class="{ 'active' : box_6_tab_open === 1 }">
              <div class="inner-tab">
                Pricing & Discounts
              </div>
            </div>
            <div class="nav-tab" @click="box_6_tab_open = 2" :class="{ 'active' : box_6_tab_open === 2 }">
              <div class="inner-tab">
                Quotes & Orders
              </div>
            </div>
            <div class="nav-tab" @click="box_6_tab_open = 3" :class="{ 'active' : box_6_tab_open === 3 }">
              <div class="inner-tab">
                Processing
              </div>
            </div>
            <div class="nav-tab" @click="box_6_tab_open = 4" :class="{ 'active' : box_6_tab_open === 4 }">
              <div class="inner-tab">
                KPI's
              </div>
            </div>
          </div>
          <div class="tab-content active _pricing-and-discounts" v-show="box_6_tab_open === 1">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Pricing & Discounts
                    </h1>
                    <p>
                      We have designed the most advanced, flexible pricing engine of any system available today.
                      So your list prices are easily managed within TOUCH.
                      But list prices are only one part of the equation and so a flexible discount structure combined
                      with the ability to set customer-specific net prices against any element allows you to fine-tune
                      the prices to your customers.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-15.png">
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _quotes-and-orders" v-show="box_6_tab_open === 2">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Quotes & Orders
                    </h1>
                    <p>
                      Being a full business management system, TOUCH Business manages your quotes and orders whether
                      processed by your customers in Portal or Connect or your own SOP staff.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-15.png">
                  <!--<img src="/images/touch-for-fabricators-page-16.png">-->
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _uplift-prices" v-show="box_6_tab_open === 3">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      Processing
                    </h1>
                    <p>
                      It is efficient to push your customers to Portal to do their own processing but TOUCH Business
                      also provides an advanced processing environment for your Sales Order Processors.
                    </p>
                    <p>
                      With the most advanced processing engine available, anything can be handled by TOUCH and your
                      processors will have access to advanced features such as complex shapes, specifications, hardware
                      placements, etc.
                    </p>
                    <p>
                      Each change whilst processing re-renders the product diagrams in real time acting as a further
                      visual check.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-15.png">
                  <!--<img src="/images/touch-for-fabricators-page-17.png">-->
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content active _process-orders" v-show="box_6_tab_open === 4">
            <div class="tab-content-inner">
              <div class="cols">
                <div class="col-info">
                  <div>
                    <h1>
                      KPI's
                    </h1>
                    <p>
                      In the normal course of business, the TOUCH system amasses a tremendous amount of information.
                      We readily present this information to you with a wide and varied array of reporting capabilities
                      and the option to export data for external analysis.
                    </p>
                  </div>
                </div>
                <div class="col-image">
                  <img src="/images/touch-for-fabricators-page-15.png">
                  <!--<img src="/images/touch-for-fabricators-page-18.png">-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="box-8">
        <div class="cols">
          <div class="col-info">
            <div>
              <div class="title-bar">
                <div class="icon">
                  <img src="/images/touch-icon-dealer-mode.png">
                </div>
                <div class="title">
                  <h1>
                    Dealer Network Mode
                    Upgrade
                  </h1>
                </div>
              </div>
              <p class="txt-lg">
                Offering and end to end solution from
                homeowner to manufacturer.
              </p>
              <p>
                Enquiries are generated via the fabricator website
              </p>
              <ul>
                <li>
                  • Warm leads are passed to preferred installers
                </li>
                <li>
                  • Installer would recieve enquiry within their Portal login
                </li>
                <li>
                  • Installers also receive an email notification
                </li>
                <li>
                  • KPI tacking of all enquiries
                </li>
                <li>
                  • Designer in sync with main ordering system
                </li>
                <li>
                  • Slimmed down questions and user friendly interface
                </li>
              </ul>
              <p>
                <strong>
                  Upgrade price for fabricators £295.00 per month
                </strong>
              </p>
            </div>
          </div>
          <div class="col-image">
            <img src="/images/touch-for-fabricators-page-19.png">
          </div>
        </div>
      </div>

      <div class="download-guide">
        <div class="col-info">
          <div>
            <h1>
              FREE TOUCH Guide
              for Fabricators
            </h1>
            <p>
              For more information on TOUCH for your business please download a complete guide.
            </p>
            <a class="btn-primary-outline" href="/documents/touch_guide.pdf" target="_blank">
              Download
            </a>
          </div>
        </div>
        <div class="col-guide">
          <a href="/documents/touch_guide.pdf" target="_blank">
            <img src="/images/touch-fabricator-guide-image.png">
          </a>
        </div>
      </div>


      <div class="support-box">
        <div class="cols">
          <div class="col-info">
            <h1>TOUCH Support</h1>
            <p>
              Dont worry if you are not tech savy, TOUCH is designed to be easy to purchase and setup in just a few
              minutes. We can also work alongside you to help with setup.
            </p>
            <p>
              Call us now for more information on 01429 239 689
            </p>
            <p>
              <a class="btn-primary-outline" @click="enquiry_box_open = true">
                Make an enquiry
              </a>
            </p>
          </div>
          <div class="col-image">
            <img src="/images/website-support-box-image.png">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Thank you for your interest</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            Your enquiry will be sent to our team, you will be sent
            a notification when you receive a reply.
          </div>
          <div class="mb-6">
            If you would like to provide some more information you can edit the message below.
          </div>
          <strong class="block pl-2 pb-1">Your Message</strong>
          <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiry()">
            Send
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'system_types',
  ],
  data() {
    return {
      'enquiry_box_open': false,
      'enquiry_message': 'I am interested in signing up for TOUCH, could I be sent some further information, thank you.',
      box_3_tab_open: 1,
      box_6_tab_open: 1,
      sending: false,
    }
  },
  methods: {
    sendEnquiry() {
      this.enquiry_box_open = false;
      this.sending = true;
      axios.post('/enquiry/send', {
        'enquiry_type_id': 23,
        'message': this.enquiry_message,
      }).then((response) => {

        gtag('event', 'enquiry_made', {
          'event_category': 'enquiries',
          'event_label': 'Touch enquiry',
          'value': 'Touch enquiry',
        });

        this.sending = false;
        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
        });
      });
    },
  },
};
</script>
